'use client'

import { useFeatureSwitch } from '@marketplace-web/feature-flags/feature-switches-data'
import { useAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { ConsentGroup, useIsConsentGroupEnabled } from '@marketplace-web/shared/consent'

import RoktAdvertisement from '../RoktAdvertisement'
import VanOfferAdvertisement from '../VanOfferAdvertisement'

const OfferAdvertisement = () => {
  const isOfferAdvertisementEnabled = useFeatureSwitch('web_offer_advertisement')

  const hasConsentedTargeting = useIsConsentGroupEnabled(ConsentGroup.Targeting)
  const hasConsentedPersonalisedAds = useIsConsentGroupEnabled(ConsentGroup.PersonalisedAds)

  const shouldUserSeeAds = useAbTest('sqp_ads')?.variant === 'on'

  const isRoktScriptEnabled = useFeatureSwitch('web_ads_rokt_script')
  const hasConsentedRokt = useIsConsentGroupEnabled(ConsentGroup.RoktAdvertising)

  const shouldShowRokt =
    isRoktScriptEnabled &&
    shouldUserSeeAds &&
    hasConsentedRokt &&
    hasConsentedTargeting &&
    hasConsentedPersonalisedAds

  if (!isOfferAdvertisementEnabled) return <RoktAdvertisement />

  return shouldShowRokt ? <RoktAdvertisement /> : <VanOfferAdvertisement />
}

export default OfferAdvertisement
